import service from './axioshttp'

let apiDomain = 'https://www.gaoyuanyunguo.com'
// apiDomain = 'http://yg.localhost.com'
let apiDomain2 = 'https://www.gaoyuanyunguo.com'
// apiDomain2 = 'http://yg.localhost.com'
// const apiDomain2 = 'http://test.yunguowang.ygcydn.com:11080'
const apiTabId = '934'

// 综合查询
const siteSearch = p => { return service.post(apiDomain + '/api/article/search', p) }
// 行业资讯
const articleList = p => { p.tag_id = apiTabId; return service.post(apiDomain + '/api/article/newsList', p) }
// 行业资讯详情
const articleDetail = p => { return service.post(apiDomain + '/api/article/detail', p) }
// 最新快讯
const fastNewsLists = p => { p.tag_id = apiTabId; return service.post(apiDomain + '/api/article/fastNewsLists', p) }
// 最新快讯年月
const fastNewsMonth = p => { p.tag_id = apiTabId; return service.post(apiDomain + '/api/article/monthList', p) }

// 通知公告
const noticeList = p => { p.tag_id = apiTabId; return service.post(apiDomain + '/api/article/noticeList', p) }

// 行业展会列表
const expoList = p => { return service.post(apiDomain + '/api/expo/lists', p) }
// 行业展会列表
const expoDetail = p => { return service.post(apiDomain + '/api/expo/detail', p) }
// 展会推荐
const recommendLists = p => { return service.post(apiDomain + '/api/expo/recommendLists', p) }

// 价格行情列表
const priceDataLists = p => { p.objectId = apiTabId; return service.post(apiDomain + '/api/price_data/lists', p) }
// 详情页获取产地列表
const priceTabLists = p => { return service.post(apiDomain + '/api/price_data/tabList', p) }
// 价格行情详情页取表格和echart数据
const priceDetail = p => { return service.post(apiDomain + '/api/price_data/detail', p) }

// 供求信息列表
const tradeLists = p => { p.tag_id = apiTabId; return service.post(apiDomain + '/api/Trade/getList', p) }
// 供求详情
const tradeInfo = p => { return service.post(apiDomain + '/api/Trade/getInfo', p) }

// 精品果园列表
const orchardLists = p => { p.tag_id = apiTabId; return service.post(apiDomain + '/api/orchard/lists', p) }

// 产业报告列表
const reportLists = p => {
  p.tag_id = apiTabId
  if (p.param) {
    p.param.tag_id = apiTabId
  }
  return service.post(apiDomain2 + '/api/article/reportLists', p)
}
// 产业报告详情
const reportDetail = p => {
  if (!p.param) {
    p['param']= {
      ...p
    }
  }

  return service.post(apiDomain + '/api/data/productDetail', p) }

// 行业内参列表
const referenceLists = p => {
  p.tag_id = apiTabId
  if (p.param) {
    p.param.tag_id = apiTabId
  }
  return service.post(apiDomain + '/api/reference/lists', p)
}
// 行业内参详情
const referenceDetail = p => { return service.post(apiDomain + '/api/reference/detail', p) }

// 企业服务列表:	金融服务 品牌服务	仓储服务 物流服务
const orgServiceLists = p => { return service.post(apiDomain + '/api/enterprise/getServiceLists', p) }
// 服务详情
const orgServiceDetail = p => { return service.post(apiDomain + '/api/enterprise/getServiceDetail', p) }

// 企业/服务商列表
const orgEnterpriseLists = p => { return service.post(apiDomain + '/api/enterprise/getEnterpriseLists', p) }

// 专家列表
const expertLists = p => { return service.post(apiDomain + '/api/expert/lists', p) }
// 专家详情
const expertDetail = p => { return service.post(apiDomain + '/api/expert/detail', p) }

// 农技知识列表
const mediaLists = p => { p.tag_id = apiTabId; return service.post(apiDomain + '/api/article/medialists', p) }
// 农技知识详情
const mediaDetail = p => { return service.post(apiDomain + '/api/article/mediaDetail', p) }

// 仓库供应列表
const whSupplylists = p => { p.tag_id = apiTabId; return service.post(apiDomain + '/api/warehouse/supplylists', p) }
// 仓库供应详情
const whSupplyDetail = p => { return service.post(apiDomain + '/api/warehouse/supplydetail', p) }

// 仓库租赁需求列表
const whRequirelists = p => { p.tag_id = apiTabId; return service.post(apiDomain + '/api/warehouse/requirelists', p) }
// 仓库租赁需求详情
const whRequireDetail = p => { return service.post(apiDomain + '/api/warehouse/requiredetail', p) }

// 物流供应列表
const tpSupplylists = p => { p.tag_id = apiTabId; return service.post(apiDomain + '/api/transport/supplylists', p) }

// 物流需求列表
const tpRequirelists = p => { p.tag_id = apiTabId; return service.post(apiDomain + '/api/transport/requirelists', p) }
// 物流需求详情
const tpRequireDetail = p => { return service.post(apiDomain + '/api/transport/requiredetail', p) }

// 仓配一体化服务
const wtServiceLists = p => { p.tag_id = apiTabId; return service.post(apiDomain + '/api/transport/warehousetransportlists', p) }

// 农资或农机分类
const meansFilterList = p => { return service.post(apiDomain + '/api/means/filterList', p) }
// 农资或农机列表
const meansLists = p => { p.tag_id = apiTabId; return service.post(apiDomain + '/api/means/lists', p) }
// 推荐农资
const meansRecommendList = p => { p.tag_id = apiTabId; return service.post(apiDomain + '/api/means/recommendList', p) }
// 农资详情或农机详情和对应的推荐
const meansDetail = p => { return service.post(apiDomain + '/api/means/detail', p) }
// 店铺下农资列表和农机列表
// const  wtServiceLists = p => {return service.post('/api/means/lists', p);}

// 获取牛油果今日价格
const avocadoTodayPrice = p => { return service.post(apiDomain2 + '/api/avocado_price_data/todayPrice', p) }
// 获取牛油果折线图价格
const getPriceData = p => { return service.post(apiDomain2 + '/api/avocado_price_data/getPriceData', p) }
// 获取牛油果价格走势列表
const getAvocadoPriceDataList = p => { return service.post(apiDomain2 + '/api/avocado_price_data/getPriceDataList', p) }
// 获取牛油果分类规格
const getAvocadoSpecList = p => { return service.post(apiDomain2 + '/api/avocado_price_data/getSpecList', p) }
// 获取市场
const getMarketList = p => { return service.post(apiDomain2 + '/api/avocado_price_data/getMarketList', p) }
// 获取牛油果分类市场分组
const getAvocadoDependencyList = p => { return service.post(apiDomain2 + '/api/avocado_price_data/getDependencyList', p) }
// 综合查询
const getServiceDetail = p => { return service.post(apiDomain2 + '/api/service/getServiceDetail', p) }

export default {
  siteSearch,
  articleList,
  articleDetail,
  fastNewsLists,
  fastNewsMonth,
  noticeList,
  expoList,
  expoDetail,
  recommendLists,
  priceDataLists,
  priceTabLists,
  priceDetail,
  tradeLists,
  tradeInfo,
  reportLists,
  reportDetail,
  referenceLists,
  referenceDetail,
  orgServiceLists,
  orgServiceDetail,
  orgEnterpriseLists,
  expertLists,
  expertDetail,
  mediaLists,
  mediaDetail,
  whSupplylists,
  whSupplyDetail,
  whRequirelists,
  whRequireDetail,
  tpSupplylists,
  tpRequirelists,
  tpRequireDetail,
  wtServiceLists,
  meansFilterList,
  meansLists,
  meansRecommendList,
  meansDetail,
  orchardLists,
  getServiceDetail,
  avocadoTodayPrice,
  getPriceData,
  getAvocadoPriceDataList,
  getAvocadoSpecList,
  getAvocadoDependencyList,
  getMarketList
}



// WEBPACK FOOTER //
// ./src/components/remote/api.js